import React, { createContext, useContext, useEffect, useState } from 'react';
import { LottiePlayer } from 'lottie-web';

const LottieContext = createContext<{ lottie: LottiePlayer | null }>({ lottie: null });
export const LottieProvider: React.FC = ({ children }) => {
  const [lottiePlayer, setLottiePlayer] = useState<LottiePlayer | null>(null);
  useEffect(() => {
    if (!lottiePlayer) {
      import('lottie-web/build/player/lottie_light')
        .then((module) => {
          setLottiePlayer(module.default);
        })
        .catch(() => null);
    }
  }, [lottiePlayer]);
  return (
    <LottieContext.Provider value={{ lottie: lottiePlayer }}>{children}</LottieContext.Provider>
  );
};
export const useLottie = () => {
  const { lottie } = useContext(LottieContext);
  return lottie;
};
